import { Button } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { useDeviceDetect } from '@fable/hooks'
import { analytics } from 'analytics'
import AnchorLink from 'react-anchor-link-smooth-scroll'

interface Props extends React.HTMLProps<HTMLDivElement> {
  title?: string
  anchorId?: string
  buttonStyles?: string
  anchor: {
    id: string
    offset?: number
    className?: string
  }
}

export const AppDownloadAnchorLink = ({
  title = 'Download the app',
  buttonStyles = '',
  anchor,
  ...nativeProps
}: Props) => {
  const { mediaQueries, colors } = useTheme()
  const { isMobile } = useDeviceDetect()

  const button = (
    <Button
      className={cx(
        css`
          width: 100%;
          padding: 0 28px;
          border-color: ${colors.uiGraphite};
          background-color: ${colors.uiGraphite};
          ${mediaQueries.mobileL} {
            width: auto;
          }
        `,
        buttonStyles
      )}
      onClick={() => isMobile && analytics.actions.appDownloadDeeplink()}
    >
      {title}
    </Button>
  )

  let content = button

  if (!isMobile) {
    content = (
      <AnchorLink
        className={anchor.className || ''}
        href={`#${anchor.id}`}
        offset={anchor.offset || 0}
      >
        {button}
      </AnchorLink>
    )
  }

  return <div {...nativeProps}>{content}</div>
}
